<template>
  <div>
    <div class="card" style="width: 300px; border-radius: 5px;">
      <div class="card-content is-size-6">
        <div class="ml-2" style="display: inline;" v-for="e in emojis" v-bind:key="e">
          <span
            v-on:click="selectedEmoji = e"
            style="font-size:2rem; padding: 4px; border-radius: 5px; "
            v-bind:class="{'has-background-grey-light': selectedEmoji == e}"
          >{{e}}</span>
        </div>
      </div>
      <footer class="card-footer">
        <p class="card-footer-item" v-on:click="cancel()">Cancel</p>
        <p class="card-footer-item" v-on:click="sendEmoji()">Send</p>
      </footer>
    </div>
  </div>
</template>

<script>
import socketStore from "@/service/socketStore";

export default {
  name: "EmojiComponent",
  data: () => {
    return {
      showEmoji: false,
      selectedEmoji: "",
      emojis: [ "👋", "✋", "👏", "🙌", "😂", "😭", "😰", "🤬", "🙇", "🤯", "🤷", "🙏", "💩", "😱", "😤", "😬", ],
    };
  },
  methods: {
    sendEmoji() {
      socketStore.emit("send_emoji", this.selectedEmoji);
      this.$emit("close-emoji");
    },
    cancel() {
      this.$emit("close-emoji");
    },
  },
};
</script>

<style>
</style>